import React from "react";
import { colors } from "../common/mixins";

interface MultipleTicketsProps {
  color?: string;
}

export const MultipleTickets = ({ color = colors.primary  }: MultipleTicketsProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_8808_28759)">
      <path
        d="M14.7955 11.9997C14.7955 11.0055 15.6013 10.1997 16.5955 10.1997V7.19971H3.39551V10.1997C4.38971 10.1997 5.19551 11.0055 5.19551 11.9997C5.19551 12.9939 4.38971 13.7997 3.39551 13.7997V16.7997H16.5955V13.7997C15.6013 13.7997 14.7955 12.9939 14.7955 11.9997Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.226 11.4404C19.469 10.4763 20.4473 9.8919 21.4114 10.1349L22.1445 7.22582L9.34473 4L8.61159 6.90904C9.57564 7.152 10.1601 8.13029 9.91712 9.09435C9.67416 10.0584 8.69587 10.6428 7.73182 10.3999L6.99867 13.3089L19.7984 16.5347L20.5316 13.6257C19.5675 13.3827 18.9831 12.4045 19.226 11.4404Z"
        fill="white"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0713 8.0332L17.7258 9.20623"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4854 10.3604L17.1398 11.5334"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8808_28759">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
